<template>
  <div class="main-container">
    <base-nav title="Статистика (Beta)" />

    <DashboardStats :company-id="companyId" />
  </div>
</template>

<script>
import { getCompanyId } from "@/utils/userUtils";

import DashboardStats from "@/components/Dashboard/DashboardStats.vue";

export default {
  name: "AnalyticsPage",

  components: {
    DashboardStats,
  },

  data() {
    return {
      companyId: getCompanyId(),
    };
  },
};
</script>

<style scoped>
.main-container {
  flex-grow: 1;
}
</style>
